import { RouteComponentProps } from 'react-router-dom'

const getPagePath = (props: RouteComponentProps, childrenPath: string = '') =>
  props.match.path + childrenPath
export default getPagePath
